import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";
import { lazy } from "react";

const UserProfile = lazy(() => import("./profile/index.jsx"));
const ProfileSettings = lazy(() => import("./profileSettings/index.jsx"));
const Inbox = lazy(() => import("./inbox/index.jsx"));

export const userRoutes = {
  children: [
    {
      path: "/user-profile/:userId",
      element: <UserProfile />,
      errorElement: <ErrorBoundary />
    }
  ]
};

export const userRoutesPrivate = {
  children: [
    {
      path: "profile-settings",
      element: <ProfileSettings />,
      errorElement: <ErrorBoundary />,
      title: "header.profileSettings"
    },
    {
      path: "inbox",
      element: <Inbox />,
      errorElement: <ErrorBoundary />,
      title: "common.inbox"
    }
  ]
};
